import {
  PerformanceAccessoryAnswer,
  StudyAhriCertificationType,
  UnitPerformanceAccessoryAnswers,
} from '@mitsubishi/shared/data-access';

import { Selection } from '../../models';

export namespace StudyActions {
  export class Open {
    static readonly type = '[Study] Open';
    constructor(public studyId: string) {}
  }

  export class Create {
    static readonly type = '[Study] Create';
    constructor(
      public certified: boolean,
      public organizationId: number,
      public systemType?: StudyAhriCertificationType
    ) {}
  }

  export class Delete {
    static readonly type = '[Study] Delete';
  }

  export class UpdateName {
    static readonly type = '[Study] Update Name';
    constructor(public name: string) {}
  }

  export class UpdateNote {
    static readonly type = '[Study] Edit Note';
    constructor(public note: string) {}
  }

  export class UpdatePerformanceData {
    static readonly type = '[Study] Update Performance Data';
    constructor(
      public subcategoryId: string,
      public workingConditionId: string,
      public performanceData: any,
      public requestTraceId?: string
    ) {}
  }

  export class CreateUnit {
    static readonly type = '[Study Unit] Create';
    constructor(
      public modelSearchUnitId: string,
      public requestTraceId?: string
    ) {}
  }

  export class DeleteUnit {
    static readonly type = '[Study Unit] Delete';
    constructor(
      public subcategoryId: string,
      public unitId: string
    ) {}
  }

  export class ToggleGoodForSelection {
    static readonly type = '[Study Unit] Toggle Good For Selection';
    constructor(
      public subcategoryId: string,
      public unitId: string,
      public performanceId: string
    ) {}
  }

  export class UpdateWorkingCondition {
    static readonly type = '[Study Working Condition] Update Working Condition';
    constructor(
      public name: string,
      public subcategoryId: string,
      public workingConditionId: string
    ) {}
  }
  export class CreateWorkingCondition {
    static readonly type = '[Study Working Condition] Create Working Condition';
    constructor(
      public subcategoryId: string,
      public requestTraceId?: string
    ) {}
  }
  export class DeleteWorkingCondition {
    static readonly type = '[Study Working Condition] Delete Working Condition';
    constructor(
      public subcategoryId: string,
      public workingConditionId: string
    ) {}
  }

  export class AddUnitToQuote {
    static readonly type = '[Study Working Condition] Add Unit To Selection';
    constructor(
      public selection: Selection,
      public unitUuid: string,
      public performanceId: string
    ) {}
  }

  export class UpdateStudyUnitNote {
    static readonly type = '[Study Unit] Update Study Unit Note';
    constructor(
      public subcategoryId: string,
      public unitUuid: string,
      public performanceId: string,
      public note: string
    ) {}
  }

  export class UpdateAddBleenGroupProgress {
    static readonly type = '[Study Unit] Update Add Bleen Group Progress';
    constructor(
      public bleenGroupId: string,
      public progress: number
    ) {}
  }

  export class DeleteSubcategory {
    static readonly type = '[Study Subcategory] Delete Subcategory';
    constructor(public subcategoryId: string) {}
  }

  export class ClearState {
    static readonly type = '[Study] Clear State';
  }
  export class GotoUnitConf {
    static readonly type = '[Study] Go to Unit Conf';
    constructor(
      public studyId: string,
      public unitId: string,
      public performanceId: string,
      public workingConditionId: string,
      public fromStudy: boolean
    ) {}
  }

  export class DownloadPerformanceRequestLog {
    static readonly type = '[Study] Download performance request';
    constructor(
      public workingConditionId: string,
      public unitId: string
    ) {}
  }

  export class AssignPerformanceAccessories {
    static readonly type = '[Study] Assign performance accessories';
    constructor(
      public performanceId: string,
      public unitId: string,
      public isTemporary: boolean,
      public answers: PerformanceAccessoryAnswer[]
    ) {}
  }

  export class AssignMultiplePerformanceAccessories {
    static readonly type = '[Study] Assign multiple performance accessories';
    constructor(
      public isTemporary: boolean,
      public unitAnswers: UnitPerformanceAccessoryAnswers[],
      public requestTraceId?: string
    ) {}
  }

  export class DuplicateUnitAndAssignPerformanceAccessories {
    static readonly type = '[Study] Duplicate unit and assign performance accessories';
    constructor(
      public performanceId: string,
      public unitId: string,
      public isTemporary: boolean,
      public answers: PerformanceAccessoryAnswer[],
      public requestTraceId?: string
    ) {}
  }

  export class DuplicateUnitAndAssignMultiplePerformanceAccessories {
    static readonly type = '[Study] Duplicate unit and assign multiple performance accessories';
    constructor(
      public unitAnswers: UnitPerformanceAccessoryAnswers[],
      public isTemporary: boolean,
      public requestTraceId?: string
    ) {}
  }

  export class EditUnitConfiguration {
    static readonly type = '[Study] Edit Unit Configuration';
    constructor(
      public studyId: string,
      public unitId: string,
      public performanceId: string,
      public workingConditionId: string,
      public fromStudy: boolean
    ) {}
  }

  export class AddExternalUnit {
    static readonly type = '[Study Unit] Add external unit';
    constructor(
      public bleenId: string,
      public quantity: number,
      public performanceId: string,
      public workingConditions: any,
      public requestTraceId?: string
    ) {}
  }

  export class UpgradeModels {
    static readonly type = '[Study] Upgrade models';
    constructor(public requestTraceId?: string) {}
  }
}
